import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  OrbitModeContainer,
  BackBtnContainer,
  DayNightToggleContainer,
  MobileOrbitModeContainer,
} from "./style/OrbitModeContainer";
import useTransitionStore from "../../../state/transitions";
import useCustomizerStore from "../../../state/customizer";
import useTimeout from "../../../hooks/useTimeout";
import BackArrow from "../../../assets/images/BackArrow.svg";
import DayToggle from "../../../assets/images/DayToggle.svg";
import NightToggle from "../../../assets/images/NightToggle.svg";
import { MobileView, isMobile } from "react-device-detect";
import ExteriorBtn from "./ExteriorBtn";
import InteriorBtn from "./InteriorBtn";
import PowertrainBtn from "./PowertrainBtn";
import HamburgerMenu from "../../../assets/images/HamburgerMenu.svg";
import closeBtn from "../../../assets/images/closeBtn.svg";
import { defaultControlAngles } from "../../../util/defaultControlAngles";
import {
  motion,
  AnimatePresence,
  MotionConfig,
  motionValue,
} from "framer-motion";
import styled from "styled-components";
import scroll from "../../../assets/animations/ClickDrag_Desktop.json";
import swipe from "../../../assets/animations/TapDrag_Mobile.json";
import Lottie from "react-lottie";

function OrbitModeUI() {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const setDisplayMode = useTransitionStore((s) => s.setDisplayMode);
  const setShowCar = useTransitionStore((s) => s.setShowCar);
  const setShowInterior = useTransitionStore((s) => s.setShowInterior);
  const setModelInHeader = useTransitionStore((s) => s.setModelInHeader);
  const setCamIndex = useTransitionStore((s) => s.setCamIndex);
  const setUpdateAssets = useTransitionStore((s) => s.setUpdateAssets);
  const UpdateAssets = useTransitionStore((s) => s.UpdateAssets);
  const setOrbitMode = useTransitionStore((s) => s.setOrbitMode);
  const DayMode = useTransitionStore((s) => s.DayMode);
  const setDayMode = useTransitionStore((s) => s.setDayMode);
  const setAzimuthAndPolarAngles = useTransitionStore(
    (s) => s.setAzimuthAndPolarAngles
  );
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const setHotspotZoomed = useTransitionStore((s) => s.setHotspotZoomed);
  const setSuspensionMode = useTransitionStore((s) => s.setSuspensionMode);
  const ShowScrollContainer = useTransitionStore((s) => s.ShowScrollContainer);
  const setShowScrollContainer = useTransitionStore(
    (s) => s.setShowScrollContainer
  );
  const DisableDayModeToggle = useTransitionStore(
    (s) => s.DisableDayModeToggle
  );
  const setDisableDayModeToggle = useTransitionStore(
    (s) => s.setDisableDayModeToggle
  );
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const setTriggerExitHotspot = useTransitionStore(
    (s) => s.setTriggerExitHotspot
  );
  const TriggerExitHotspot = useTransitionStore((s) => s.TriggerExitHotspot);
  const setFutureSelectedHotspotTitle = useCustomizerStore(
    (s) => s.setFutureSelectedHotspotTitle
  );
  const setFutureSelectedHotspotDescription = useCustomizerStore(
    (s) => s.setFutureSelectedHotspotDescription
  );
  const setSelectedDisclaimer = useCustomizerStore(
    (s) => s.setSelectedDisclaimer
  );
  const setSelectedHotspot = useCustomizerStore((s) => s.setSelectedHotspot);
  const setFilterHotspots = useCustomizerStore((s) => s.setFilterHotspots);
  const filterHotspots = useCustomizerStore((s) => s.filterHotspots);

  const [Day, setDay] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const isQuestBrowser =
    typeof navigator !== "undefined" &&
    /OculusBrowser|Meta Quest/i.test(navigator.userAgent);

  const mode = useRef("flipper");

  const toggleAssets = useCallback(() => {
    if (mode.current === "interior") {
      setShowCar(false);
      setShowInterior(true);
      setDelay(null);
    } else if (mode.current === "exterior") {
      setShowCar(true);
      setShowInterior(false);
      setDelay(null);
    } else if (mode.current === "powertrain") {
      setShowInterior(false);
      setShowCar(true);
      setDelay(null);
    }
  });

  useEffect(() => {
    toggleAssets();
  }, [UpdateAssets]);

  const [Delay, setDelay] = useState(null);
  useTimeout(() => setUpdateAssets(!UpdateAssets), Delay);

  useEffect(() => {
    if (
      DisplayMode === "exterior" ||
      DisplayMode === "interior" ||
      DisplayMode === "powertrain"
    ) {
      setTimeout(() => {
        setShowScrollContainer(true);
      }, 1500);
    }
  }, [DisplayMode]);

  return (
    <>
      {DisplayMode !== "flipper" && (
        <>
          {!menuOpen && (
            <>
              {DisplayMode === "exterior" && !SuspensionMode && (
                <DayNightToggleContainer
                  key="day-night-toggle"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  top={isMobile ? "var(--orbit-controls-top, calc(60px + 16px))" : null}
                  left={isMobile ? "50%" : null}
                  transform={
                    isMobile ? "transform: translateX(-50%)" : null
                  }
                  height={isMobile ? "32px" : "auto"}
                >
                  <img
                    onClick={() => {
                      if (!DisableDayModeToggle) {
                        mode.current = "exterior";
                        setShowInterior(false);
                        if (DisplayMode !== "exterior")
                          setDisplayMode("exterior");
                        setModelInHeader(false);
                        setShowCar(true);
                        setCamIndex(1);
                        setDay(!Day);
                        if (DayMode == "day") setDayMode("night");
                        else setDayMode("day");
                        setDelay(0);
                        setDisableDayModeToggle(true);
                      }
                    }}
                    src={DayMode == "day" ? DayToggle : NightToggle}
                    alt="Switch Between Day and Night Mode"
                  />
                </DayNightToggleContainer>
              )}
              <BackBtnContainer
                key="back-btn-container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                width={isMobile ? "32px" : "auto"}
                height={isMobile ? "32px" : "auto"}
                top={isMobile ? "var(--orbit-controls-top, calc(60px + 16px))" : null}
              >
                <img
                  onClick={() => {
                    mode.current = "flipper";
                    setShowInterior(false);
                    setDisplayMode("flipper");
                    setModelInHeader(false);
                    setShowCar(true);
                    setOrbitMode(false);
                    setDelay(0);
                    setDayMode("night");
                    setShowScrollContainer(false);
                    setCamIndex(0);
                    setAzimuthAndPolarAngles(defaultControlAngles);
                    setHotspotControls(false);
                    setHotspotZoomed(false);
                    setSuspensionMode(false);
                    setSelectedHotspot("");
                    setSelectedDisclaimer("");
                    setFutureSelectedHotspotDescription("");
                    setFutureSelectedHotspotTitle("");
                    if (filterHotspots) setFilterHotspots(false);
                  }}
                  src={BackArrow}
                  alt="Back Button To Select Model"
                />
              </BackBtnContainer>
            </>
          )}
          {(isQuestBrowser || !isMobile) && (
            <>
              <OrbitModeContainer>
                <motion.div
                  key="view-btn-container"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="wrapper"
                >
                  <ExteriorBtn
                    mode={mode}
                    Delay={Delay}
                    setDelay={setDelay}
                    Day={Day}
                    setDay={setDay}
                    toggleAssets={toggleAssets}
                  />
                  <InteriorBtn
                    mode={mode}
                    Delay={Delay}
                    setDelay={setDelay}
                    Day={Day}
                    setDay={setDay}
                  />
                  <PowertrainBtn
                    mode={mode}
                    Delay={Delay}
                    setDelay={setDelay}
                    Day={Day}
                    setDay={setDay}
                  />
                </motion.div>
              </OrbitModeContainer>
              <AnimatePresence>
                {ShowScrollContainer && (
                  <ScrollContainer
                    key="scroll-orbit-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    isMobile={false}
                  >
                    <Lottie
                      width={200}
                      height={200}
                      options={{
                        loop: true,
                        autoplay: true,
                        animationData: scroll,
                        rendererSettings: {
                          preserveAspectRatio: "xMidYMid slice",
                        },
                      }}
                    />
                    <span>Click and drag to rotate</span>
                  </ScrollContainer>
                )}
              </AnimatePresence>
            </>
          )}
          {!isQuestBrowser && (
            <MobileView>
              <MobileOrbitModeContainer>
                <div
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "66px",
                    background: menuOpen ? "black" : "transparent",
                    top: "var(--app-header-height, 60px)",
                    zIndex: 999,
                    border: "none",
                    transition: "background 0.7s ease-in-out",
                    pointerEvents: "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: menuOpen ? "space-between" : "end",
                      padding: "0 16px 0 16px", //"0 16px 0 16px"
                      height: "100%",
                      border: "none",
                      transition: "color 0.3s ease-in-out",
                      pointerEvents: menuOpen ? "auto" : "none",
                    }}
                  >
                    {menuOpen ? (
                      <>
                        <ExteriorBtn
                          mode={mode}
                          Delay={Delay}
                          setDelay={setDelay}
                          Day={Day}
                          setDay={setDay}
                        />
                        <InteriorBtn
                          mode={mode}
                          Delay={Delay}
                          setDelay={setDelay}
                          Day={Day}
                          setDay={setDay}
                        />
                        <PowertrainBtn
                          mode={mode}
                          Delay={Delay}
                          setDelay={setDelay}
                          Day={Day}
                          setDay={setDay}
                        />
                      </>
                    ) : null}
                    <img
                      style={{
                        width: "32px",
                        height: "33px",
                        pointerEvents: "auto",
                      }}
                      onClick={() => {
                        setMenuOpen(!menuOpen);
                      }}
                      src={!menuOpen ? HamburgerMenu : closeBtn}
                      alt="Menu Close Button"
                    />
                  </div>
                </div>
              </MobileOrbitModeContainer>
              <AnimatePresence>
                {ShowScrollContainer && !SuspensionMode && (
                  <ScrollContainer
                    key="scroll-orbit-mobile-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    isMobile
                  >
                    <Lottie
                      width={200}
                      height={200}
                      options={{
                        loop: true,
                        autoplay: true,
                        animationData: swipe,
                        rendererSettings: {
                          preserveAspectRatio: "xMidYMid slice",
                        },
                      }}
                    />
                    <span>Tap and drag to rotate</span>
                  </ScrollContainer>
                )}
              </AnimatePresence>
            </MobileView>
          )}
        </>
      )}
    </>
  );
}

const ScrollContainer = styled(motion.div)`
  position: absolute;
  width: 100%;
  bottom: ${({ isMobile }) => (isMobile ? "120px" : "64px")};
  pointer-events: none;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    color: #fff;
    margin-top: -60px;
  }

  @media (max-width: 1120px) {
    display: none;
  }
`;

export default React.memo(OrbitModeUI);
